module.exports = __webpack_public_path__ + "static/media/covi_per_cou_eti.9d3bddee.png";